// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { recentWishListsStyles } from "@sc/Overrides/Widgets/Common/RecentWishLists";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { color, createLinkIconStyles, ellipsis, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.titleTypography = {
    title: {
        variant: "h4",
        forwardAs: "p",
        css: css`
            margin-bottom: 0;
        `,
    },
    link: {
        ...createLinkIconStyles(ArrowRight, {
            icon: {
                position: "right",
                iconProps: {
                    size: 13,
                    css: css`
                        &${IconWrapper}, svg {
                            width: 11px;
                        }
                    `,
                },
            },
            typographyProps: {
                size: 12,
                lineHeight: "14px",
            },
        }),
    },
};

recentWishListsStyles.noResults = {
    css: css`
        margin-bottom: 0;
    `,
};
recentWishListsStyles.wishListCardWrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        padding: 13px;
        width: calc((100% - 44px) / 3);
        ${xScreen("lte", "md")} {
            width: calc(50% - 10px);
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
recentWishListsStyles.cardsWrapper = {
    css: css`
        display: flex;
        row-gap: 20px;
        column-gap: 22px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
    `,
};

recentWishListsStyles.wishListCard = {
    gridContainer: {
        gap: 24,
    },
    basicInfoGridItem: {
        width: 12,
    },
    extendedInfoGridContainer: {
        gap: 0,
        css: css`
            width: 100%;
        `,
    },
    wishListInfoGridContainer: {
        gap: 0,
    },
    extendedInfoGridItem: {
        width: 12,
    },
    sharingStatusGridItem: {
        width: 12,
        css: css`
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: row-reverse;
        `,
    },
    sharingStatus: {
        statusText: {
            css: css`
                flex: 1;
            `,
        },
    },
    basicInfoGridContainer: {
        gap: 0,
        css: css`
            margin-left: 0;
        `,
    },
    detailIconGridItem: {
        css: css`
            display: none;
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding-bottom: 8px;
        `,
    },
    detailLinkGridItem: {
        width: 12,
        css: css`
            padding-bottom: 8px;
        `,
    },
    descriptionText: {
        forwardAs: "p",
        size: 16,
        lineHeight: "17px",
        weight: "bold",
        css: css`
            min-height: 34px;
            ${ellipsis(2)}
        `,
    },
    detailLink: {
        typographyProps: {
            size: 16,
            lineHeight: "17px",
            weight: "bold",
            css: css`
                min-height: 34px;
                ${ellipsis(2)}
            `,
        },
    },
    lastUpdatedGridItem: { width: 12 },
    lastUpdatedText: {
        size: 12,
        lineHeight: "14px",
        css: css`
            margin-bottom: 12px;
        `,
    },
    itemsSmallHeading: {
        ...createHorizontalSmallHeadingAndTextStyles({
            wrapper: {
                css: css`
                    width: auto;
                `,
            },
            heading: {
                weight: "normal",
            },
            text: {
                weight: "bold",
            },
        }),
    },
};
